import { FC, ReactNode, useRef } from 'react';
import { Alignment } from '../../types/DomainTypes';

interface Props {
  children: ReactNode;
  tooltip?: ReactNode;
  align?: Alignment;
  /** Vertical position: 'bottom' shows tooltip below, 'top' shows tooltip above */
  position?: 'top' | 'bottom';
  /** Horizontal position: 'left' aligns to left edge, 'right' aligns to right edge, 'center' centers */
  horizontalPosition?: 'left' | 'right' | 'center';
}

const ToolTip: FC<Props> = ({
  children,
  tooltip,
  align = Alignment.CENTER,
  position = 'bottom',
  horizontalPosition = 'center',
}): JSX.Element => {
  const tooltipRef = useRef<HTMLDivElement>(null);
  const container = useRef<HTMLDivElement>(null);

  // Horizontal alignment classes
  const getHorizontalAlignment = () => {
    if (horizontalPosition === 'left') {
      return 'left-0'; // Align tooltip's left edge with trigger's left edge
    }
    if (horizontalPosition === 'right') {
      return 'right-0'; // Align tooltip's right edge with trigger's right edge
    }
    // Center alignment (default) - use legacy align prop behavior
    if (align === Alignment.CENTER) {
      return '-translate-x-1/2 left-1/2';
    }
    if (align === Alignment.RIGHT) {
      return '-translate-x-full left-5';
    }
    return 'left-0'; // Alignment.LEFT
  };

  const verticalPosition = position === 'top' ? 'bottom-full mb-2' : 'top-full mt-2';
  const horizontalAlignment = getHorizontalAlignment();

  return (
    <div ref={container} className="group relative inline-block">
      {children}
      {tooltip ? (
        <div
          ref={tooltipRef}
          className={`invisible z-[100] group-hover:visible opacity-0
           group-hover:opacity-100 transition
           rounded absolute ${verticalPosition} ${horizontalAlignment}`}
        >
          {tooltip}
        </div>
      ) : null}
    </div>
  );
};

export default ToolTip;
